import { render } from "./CreateByKdd.vue?vue&type=template&id=27699f1e"
import script from "./CreateByKdd.vue?vue&type=script&lang=js"
export * from "./CreateByKdd.vue?vue&type=script&lang=js"

import "./CreateByKdd.vue?vue&type=style&index=0&id=27699f1e&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__